<div class="flex flex-col gap-2 w-full relative minw-44">
    <h5 *ngIf="label" class="text-xs text-zen font-medium truncate whitespace-nowrap">{{ label }} <i *ngIf="required"
            class="fa-regular fa-asterisk text-3xs transform -translate-y-1"></i></h5>
    <div [class]='customClass()' class="rounded text-zen border truncate flex flex-row gap-3  justify-between items-stretch" [ngClass]="{'border-zen-red':field.invalid && (field.dirty || field.touched)|| (field.invalid && invalid), 'bg-zen bg-opacity-20':isDisabled, 'bg-white':!isDisabled }">
        <div class="flex flex-row items-stretch px-3 w-full gap-2"  >
            <input (keyup)="change($event)" [maxlength]="maxCount" autocomplete="false"
                [disabled]="isDisabled || (selected?.length > maxCount +1 && maxCount)" [required]="required"
                [pattern]="email?emailPattern:false" #field="ngModel" type="text"
                [placeholder]="placeholder?placeholder:''"
                class="text-sm text-zen w-full h-full border-none bg-transparent" [ngModel]="selected"
                (ngModelChange)="handleChange($event)" [email]="email && !number"
                [type]="email?'email':(password && hide?'password':'text')"
               >
        </div>

        @if (password) {
        <i [zenButton]="{type:ZenButtonType.Secondary, icon:true}" (click)="toggleHide()"
            [ngClass]="hide? 'fa-eye-slash' : 'fa-eye' " class="fa-regular leading-[inherit] h-[inherit]"></i>
        }

        <!-- <button *ngIf="password" (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <i [className]="hide? 'is-size-5 iconBlackBack fas fa-eye-slash' : 'is-size-5 fas fa-eye' "></i>
      </button> -->
    </div>

</div>

<div *ngIf="invalid || selected?.length > maxCount -5"
    class="flex flex-row justify-between h-0 transform translate-y-1">
    <div class="alert alert-danger ">
        <validation-required [language]="language" *ngIf="field.errors?.required "></validation-required>
        <validation-email [language]="language" *ngIf="field.errors?.pattern"></validation-email>
    </div>
    <div *ngIf="selected?.length > maxCount -5 && maxCount"
        class="text-red-600 text-xxs flex flex-row items-center gap-1 leading-5">
        {{maxCount}}/{{selected?.length}}</div>
</div>